<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Custom Email Settings</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf='isLoadingPage'></salonmonster-load-mask>  

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingPage" (click)="loadPage()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoadingPage && !errorOccurredWhileLoadingPage">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>
      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <form [formGroup]='settingsForm'>
          <ion-item class="ion-text-wrap">
            This is where you can customize your emails
          </ion-item>

          <ion-item>
            <ion-label>Same custom emails for all staff</ion-label>
            <ion-toggle formControlName="sameCustomizedEmailsForAllStaff" (ionChange)="onToggleChange($event)"></ion-toggle>
          </ion-item>

          <smr-stylist-picker 
            *ngIf="!sameCustomizedEmailsForAllStaff.value"
            [stylistID]="stylistID"
            [readOnly]="readOnlyStylistPicker"
            (onInit)="onStylistPickerInit($event)"
            (stylistSelect)="onStylistSelect($event)"
            cssClass="smr-stylist-picker-for-customemails">
          </smr-stylist-picker>
          <!--salonmonster-load-mask *ngIf='isLoadingStylistPicker'></!--salonmonster-load-mask>  

          <salonmonster-tap-retry-- *ngIf="errorOccurredWhileLoadingStylistPicker" (click)="onTapToReloadStylistPicker()"></salonmonster-tap-retry-->
          <ng-container>

            <ion-card>
              <ion-card-header><ion-card-title>Booking request</ion-card-title></ion-card-header>
              
              <ion-card-content>
                <quill-editor class="quill-custom-email" formControlName="bookingRequest" [modules]="config"></quill-editor>
                <!-- <span>{{bookingRequest.value}}</span> -->
              </ion-card-content>
            </ion-card>

            <ion-card>
              <ion-card-header><ion-card-title>Booking confirmation</ion-card-title></ion-card-header>
              
              <ion-card-content>
                <quill-editor class="quill-custom-email" formControlName="bookingConfirmation" [modules]="config"></quill-editor>
              </ion-card-content>
            </ion-card>

            <ion-card>
              <ion-card-header><ion-card-title>Booking cancelled</ion-card-title></ion-card-header>
              
              <ion-card-content>
                <quill-editor class="quill-custom-email" formControlName="bookingCancelled" [modules]="config"></quill-editor>
              </ion-card-content>
            </ion-card>

            <ion-card>
              <ion-card-header><ion-card-title>Booking reminder</ion-card-title></ion-card-header>
              
              <ion-card-content>
                <quill-editor class="quill-custom-email" formControlName="bookingReminder" [modules]="config"></quill-editor>
              </ion-card-content>
            </ion-card>

            <br/>
            <br/>
            <ion-button 
              expand="block"
              class="hidden-sm-down"
              [disabled]="isLoadingPage || errorOccurredWhileLoadingPage || (!sameCustomizedEmailsForAllStaff.value && (isLoadingStylistPicker || errorOccurredWhileLoadingStylistPicker))" 
              (click)="onSettingsSave()">
              Save
            </ion-button>
          </ng-container>

          <br/>
          <br/>
          <br/>
          <br/>
        </form>

      </ion-col>
      <ion-col class="hidden-sm-down"></ion-col>    
    </ion-row>
  </ng-container>
</ion-content>

<ion-footer class="ion-no-margin" class="hidden-md-up">
  <ion-toolbar class="ion-no-margin ion-no-padding">{{screenSize}}
    <ion-button 
      class="ion-no-margin"
      expand="block" 
       
      color="primary"
      fill="solid"
      [disabled]="isLoadingPage || errorOccurredWhileLoadingPage || (!sameCustomizedEmailsForAllStaff.value && (isLoadingStylistPicker || errorOccurredWhileLoadingStylistPicker) )" 
      (click)="onSettingsSave()">
      Save
  </ion-button>
  </ion-toolbar>
</ion-footer>